/* tslint:disable */
/* eslint-disable */
/**
 * Prove Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  GetHistories200Response,
  InternalServerError,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    GetHistories200ResponseFromJSON,
    GetHistories200ResponseToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
} from '../models/index';

export interface GetHistoriesRequest {
    orderNo?: string;
    companyCode?: string;
    radioNo?: string;
    loginId?: string;
    status?: number;
    count?: number;
    timestampFrom?: Date;
    timestampTo?: Date;
}

/**
 * 
 */
export class ProbeApi extends runtime.BaseAPI {

    /**
     * get probe history
     */
    async getHistoriesRaw(requestParameters: GetHistoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHistories200Response>> {
        const queryParameters: any = {};

        if (requestParameters['orderNo'] != null) {
            queryParameters['order_no'] = requestParameters['orderNo'];
        }

        if (requestParameters['companyCode'] != null) {
            queryParameters['company_code'] = requestParameters['companyCode'];
        }

        if (requestParameters['radioNo'] != null) {
            queryParameters['radio_no'] = requestParameters['radioNo'];
        }

        if (requestParameters['loginId'] != null) {
            queryParameters['login_id'] = requestParameters['loginId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['timestampFrom'] != null) {
            queryParameters['timestamp_from'] = (requestParameters['timestampFrom'] as any).toISOString();
        }

        if (requestParameters['timestampTo'] != null) {
            queryParameters['timestamp_to'] = (requestParameters['timestampTo'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/histories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHistories200ResponseFromJSON(jsonValue));
    }

    /**
     * get probe history
     */
    async getHistories(requestParameters: GetHistoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHistories200Response> {
        const response = await this.getHistoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
